import React, { useState } from 'react'
import { BlackCircle, Collapsable, Flex } from 'styling/GlobalStyles'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { CollapseItemText } from 'components/CollapseItem/CollapseItem.styled'
import Chevron from 'assets/icons/Chevron'
import { ITaskTemplateState } from 'types/task-templates.interface'
import { Input } from 'components/Input/Input'

export const CollapseItemOperationTask = ({ state, setState }: ICollapseItemOperationTask) => {
  const [expanded, setExpanded] = useState(true)
  const handleRemove = () => {
    setState((prev) => ({ ...prev, operation: null, operationParameterValues: [] }))
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>, parameterId: number) => {
    const raw = e.target.value
    const nextValue = raw === '' ? null : e.target.valueAsNumber

    setState(prev => ({
      ...prev,
      operationParameterValues: prev.operationParameterValues.map(v => ({
        ...v,
        defaultValue: v.operationParameter.id === parameterId ? nextValue : v.defaultValue
      })),
    }))
  }

  console.log(state)

  return (
    <Collapsable expanded={expanded}>
      <Flex mb='20'>
        <CollapseItemText expanded={expanded} onClick={() => setExpanded((prev) => !prev)}>
          {state?.operation?.name} <Chevron gray />
        </CollapseItemText>

        <BlackCircle onClick={handleRemove}>
          <RemoveCircle white />
        </BlackCircle>
      </Flex>
      <Flex width='100%' gap='1rem' wrap >
        {state.operationParameterValues.map(v => (
          <Input
            width='150px'
            placeholder='Enter value...'
            onChange={(e) => onChange(e, v.operationParameter.id)}
            value={v.defaultValue}
            type='number'
            labelText={v.operationParameter.name}
            key={v.operationParameter.id}
            nomarg
          />
        ))}
      </Flex>

    </Collapsable>
  )
}


interface ICollapseItemOperationTask {
  setState: React.Dispatch<React.SetStateAction<ITaskTemplateState>>
  state: ITaskTemplateState
}